// extracted by mini-css-extract-plugin
export default {"wrapper":"A0-z","play":"B0-z"};